var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.title1,
        visible: _vm.innerVisible,
        "append-to-body": "",
      },
      on: {
        close: function ($event) {
          _vm.innerVisible = false
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "app-container" },
        [
          _c(
            "div",
            { attrs: { id: "table-content" } },
            [
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.crud.loading,
                      expression: "crud.loading",
                    },
                    {
                      name: "sticky",
                      rawName: "v-sticky",
                      value: { top: 0 },
                      expression: "{ top: 0 }",
                    },
                  ],
                  staticClass: "sticky-head",
                  staticStyle: { width: "100%" },
                  attrs: {
                    border: "",
                    data: _vm.crud.data,
                    "header-cell-style": {
                      background: "#f6f7fa",
                      color: "#606266",
                    },
                    "max-height": "800",
                  },
                },
                _vm._l(_vm.titleData, function (col) {
                  return _c("el-table-column", {
                    attrs: {
                      prop: col.title,
                      label: col.name ? col.name : col.title,
                      "min-width": col.width ? col.width : 120,
                      "show-overflow-tooltip": "true",
                      "column-key": col.title,
                    },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("pagination"),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }